module.exports = __webpack_public_path__ + "img/385.74170d46.png";